// src/Airplane.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Airplane_default = createIcon({
  displayName: "Airplane",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2C10.8954 2 10 2.89543 10 4V9.37891L2.49023 14.0684C2.18523 14.2594 2 14.5931 2 14.9531C2 15.6581 2.68247 16.1612 3.35547 15.9512L10 13.8809V19.2402L8.33789 20.4824C8.12489 20.6414 8 20.8922 8 21.1582C8 21.7062 8.51587 22.1076 9.04688 21.9746L12 21.2363L14.9531 21.9746C15.4841 22.1076 16 21.7062 16 21.1582C16 20.8922 15.8751 20.6414 15.6621 20.4824L14 19.2402V13.8809L20.6445 15.9512C21.3175 16.1612 22 15.6581 22 14.9531C22 14.5931 21.8148 14.2594 21.5098 14.0684L14 9.37891V4C14 2.89543 13.1046 2 12 2Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Airplane_default
};
